import { AUTH_COOKIE, getCookie } from './cookies';
import handleFetchResponse from './handleFetchResponse';
export default (
  url,
  options,
  callback,
  includeCredentials = true,
  catchCallback,
  finallyCallback
) => {
  new Promise((resolve, reject) => {
    if (typeof url !== 'string') reject(new Error('Invalid parameter: url'));
    if (typeof options !== 'object' && options !== null)
      reject(new Error('Invalid parameter: options'));
    if (typeof callback !== 'function') reject(new Error('Invalid parameter: callback'));

    const authToken = getCookie(AUTH_COOKIE);

    const settings = {
      method: 'post',
      ...(includeCredentials && { credentials: 'include' }),
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        ...(!!authToken && { authorization: `Bearer ${authToken}` }),
      },
      body: JSON.stringify(options),
    };

    resolve(fetch(url, settings));
  })
    .then(handleFetchResponse)
    .then(callback)
    .catch((error) => {
      if (typeof catchCallback === 'function') {
        catchCallback(error);
      } else {
        console.error(error);
      }
    })
    .finally(() => {
      if (typeof finallyCallback === 'function') {
        finallyCallback();
      }
    });
};
